export function getDeep(obj, ...props) {
  let prop = props.shift();
  if (obj[prop]) {
    if (props.length) {
      return getDeep(obj[prop], ...props);
    }
  }
  return obj[prop];
}

export function isLoggedIn() {
  return localStorage.loginToken !== undefined && localStorage.loginToken !== "invalid";
}



// WEBPACK FOOTER //
// ./components/Utils.js